<mat-toolbar class="flex justify-between">
  <button
    class="btn-normal order-1"
    (click)="doShowLeftMenu()"
    aria-label="main menu"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <span class="order-2 w-full text-center">{{ label() }} </span>
  <button
    class="btn-normal order-3"
    (click)="doShowRightMenu()"
    [matMenuTriggerFor]="menu"
  >
    <mat-icon>more_vert</mat-icon>
  </button>
</mat-toolbar>
<div class="flex">
  <span>{{ loginStatus }}</span
  ><span>版本:{{ version }}</span
  ><span>公司別:{{ login.dbname }}</span
  ><span>使用者:{{ login.UserName }}</span>
</div>
<mat-menu #menu="matMenu">
  <button mat-menu-item>
    <img matChipAvatar [src]="avatarIcon" [width]="48" [height]="48" />
    {{ username }}
  </button>
  <mat-divider></mat-divider>
  @if (!isLogin) {
    <button mat-menu-item (click)="doLogin()">登入</button>
  }
  @if (isLogin) {
    <button mat-menu-item (click)="logout()">登出</button>
  }
  <button mat-menu-item (click)="doMyAbout()">關於</button>
  <button mat-menu-item (click)="doUpdate()">
    更新程式(版本:{{ version }})
  </button>
</mat-menu>
